import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchInstalmentPlanTemplate, createInstalmentPlanTemplate, updateInstalmentPlanTemplate } from './actions';
import InstalmentPlanTemplateSettingsForm, { selector as instalmentPlanTemplateSettingsFormSelector } from './SettingsForm';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import { Panel } from 'react-bootstrap';
import ui from '../../common/services/ui';
class Details extends Component {
	constructor(props) {
		super(props);
		this.handleInstalmentPlanTemplateSettingsSubmit = this.handleInstalmentPlanTemplateSettingsSubmit.bind(this);

	}

	componentDidMount() {
		const { match, fetchInstalmentPlanTemplate } = this.props;
		const instalmentPlanTemplateId = match.params.id;

		if (instalmentPlanTemplateId) {
			fetchInstalmentPlanTemplate(instalmentPlanTemplateId);
		}
	}
	componentWillReceiveProps(nextProps) {

	}

	handleInstalmentPlanTemplateSettingsSubmit(values) {
		const { instalmentPlanTemplate, createInstalmentPlanTemplate, updateInstalmentPlanTemplate, history } = this.props;

		let newValues = { ...values };

		if (newValues["usageType"]) {
			newValues["usageType"] = newValues["usageType"]
				.map(entry => entry.value)
				.reduce((accumulator, currentValue) => accumulator | currentValue);
		}

		if (instalmentPlanTemplate) {
			updateInstalmentPlanTemplate(instalmentPlanTemplate.id, newValues);
		} else {
			createInstalmentPlanTemplate(newValues, history);
		}
	}

	prepareUsageTypes(instalmentUsageTypes) {
		if (!instalmentUsageTypes) {
			return [];
		}

		return Object.keys(instalmentUsageTypes)
			.map(id => {
				const entry = instalmentUsageTypes[id];
				return { value: entry.id, label: entry.displayName };
			});
	}

	render() {
		const { instalmentPlanTemplate, instalmentIntervalTypes, instalmentPlanFormValues, isReadonly, instalmentUsageTypes,
			offerIndividualConsultations, offerWorkshops, weekDays, daysOfMonth, isRestrictedUser, t } = this.props;
		const usageTypes = this.prepareUsageTypes(instalmentUsageTypes);

		let initialValues = {
			intervalType: 1, instalmentStart: 1, depositPayments: 0, totalPayments: 1,
			intervalLength: 1, minLessonCount: 0, minOrderAmount: 0, enabled: true
		};
		if (instalmentPlanTemplate) {
			initialValues = { ...initialValues, ...instalmentPlanTemplate };
			initialValues.usageType = this.prepareUsageTypes(instalmentPlanTemplate.usageType);
		}
		else {
			const defaultUsageType = instalmentUsageTypes && instalmentUsageTypes.filter(item => item.id === 1);
			initialValues.usageType = this.prepareUsageTypes(defaultUsageType);
		}


		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<InstalmentPlanTemplateSettingsForm isReadonly={isReadonly} onSubmit={this.handleInstalmentPlanTemplateSettingsSubmit} initialValues={initialValues}
					instalmentIntervalTypes={instalmentIntervalTypes} usageTypes={usageTypes} weekDays={weekDays} daysOfMonth={daysOfMonth}
					offerIndividualConsultations={offerIndividualConsultations} offerWorkshops={offerWorkshops} {...instalmentPlanFormValues}
					isRestrictedUser={isRestrictedUser}
				/>
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const instalmentPlanTemplateId = ownProps.match.params.id;
	
	const {
		entities: { instalmentPlanTemplates },
		lookups: { instalmentIntervalTypes, instalmentUsageTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const instalmentPlanTemplate = instalmentPlanTemplates[instalmentPlanTemplateId];
	return {
		instalmentPlanTemplate,
		isReadonly: instalmentPlanTemplate && instalmentPlanTemplate.isReadonly,
		instalmentIntervalTypes,
		instalmentUsageTypes,
		daysOfMonth: ui.daysOfMonth(),
		offerIndividualConsultations: franchisor.offerIndividualConsultations,
		offerWorkshops: franchisor.offerWorkshops,
		weekDays: Object.keys(ui.days).filter(key => Number(key) > 0),
		instalmentPlanFormValues: instalmentPlanTemplateSettingsFormSelector(state, 'intervalType', 'instalmentStart', 'intervalLength'),
		isRestrictedUser: currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted
	};
};

export default connect(mapStateToProps, {
	fetchInstalmentPlanTemplate,
	createInstalmentPlanTemplate,
	updateInstalmentPlanTemplate
})(withTranslation()(Details));